module.exports = __webpack_public_path__ + "img/hr-green-carpet-grass-05.475e6601.png";